import { render, staticRenderFns } from "./AdminInterliningsScreen.vue?vue&type=template&id=1e640874&scoped=true&"
import script from "./AdminInterliningsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminInterliningsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e640874",
  null
  
)

export default component.exports